import { render, staticRenderFns } from "./LibraryItemFormScreen.vue?vue&type=template&id=bb847518&"
import script from "./LibraryItemFormScreen.vue?vue&type=script&lang=ts&"
export * from "./LibraryItemFormScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports